import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const ArrowRightFromBracket = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0  512 512"
      {...props}
    >
      <path
        opacity={0.2}
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 192 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"
      />
    </SvgIcon>
  );
};
